import { ProfilePage } from '@/features/users/pages/ProfilePage';

export const userRoutes = [{ path: 'profile', element: <ProfilePage /> }];
